(function () {
    'use strict';

    angular.module('PWAPoCApp').factory('mapUtility', mapUtility);

    mapUtility.$inject = [];

    var utm33N = '+proj=utm +zone=33 +ellps=WGS84 +datum=WGS84 +units=m +no_defs',
        wgs84 = '+proj=longlat +ellps=WGS84 +datum=WGS84 +no_defs';

    function mapUtility() {
        var service = {
            convertToUTM33N,   //32633
            convertToWGS84,     //4326
            getAngleDiff,
            hasPositionChanged,
            isValidPosition
        };

        return service;

        function convertToUTM33N(lat, lng) {
            var projectedCoords = proj4(utm33N, [lng, lat]);
            return {
                X: projectedCoords[0],
                Y: projectedCoords[1]
            };
        }

        function convertToWGS84(x, y) {
            var projectedCoords = proj4(utm33N, wgs84, [x, y]);

            return {
                latitude: projectedCoords[1],
                longitude: projectedCoords[0]
            };
        }

        function isValidPosition(position) {
            return (position
                && position.coords
                && position.coords.latitude
                && position.coords.longitude
            );
        }

        function hasPositionChanged(oldPosition, newPosition) {
            if (typeof (oldPosition) === 'undefined' && typeof (newPosition) !== 'undefined') {
                return true;
            }

            return (
                oldPosition.coords.latitude !== newPosition.coords.latitude ||
                oldPosition.coords.longitude !== newPosition.coords.longitude
            );
        }

        function getAngleDiff(currentPosition, otherPosition) {
            var dy = otherPosition.coords.longitude - currentPosition.coords.longitude;
            var dx = otherPosition.coords.latitude - currentPosition.coords.latitude;

            var theta = Math.atan2(dy, dx);
            theta *= 180 / Math.PI;
            if (theta < 0) theta = 360 + theta;

            return theta;
        }
    }
})();
